import Factory from './factory';

export default {

  init: function(node) {
    console.log('Initializing Parallax');

    var $node = $(node);
    var parallaxOptions = {
      offset: $node.data('bg-offset'),
      bgY: $node.data('bg-y'),
      type: $node.data('animation-type'),
      $element: $node
    };

    return new Factory(parallaxOptions);
  }
};